const DOMAINS = [
    'gmail.com', 'yahoo.com', 'hotmail.com', 'outlook.com', 'aol.com',
    'icloud.com', 'me.com', 'mac.com', 'msn.com', 'live.com',
    'comcast.net', 'verizon.net', 'sbcglobal.net', 'att.net', 'bellsouth.net',
    'ymail.com', 'rocketmail.com', 'mail.com', 'protonmail.com', 'proton.me',
    'gmx.com', 'fastmail.com'
];

const TLDS = [
    'com', 'net', 'org', 'edu', 'gov', 'co', 'io', 'us', 'ca', 'uk',
    'co.uk', 'au', 'com.au', 'de', 'fr', 'es', 'it', 'nl', 'jp', 'me'
];

const THRESHOLD = 3;

const sift3Distance = (s1, s2) => {
    if (!s1 || !s1.length) return s2 ? s2.length : 0;
    if (!s2 || !s2.length) return s1.length;

    let c = 0, offset1 = 0, offset2 = 0, lcs = 0;
    const maxOffset = 5;

    while ((c + offset1 < s1.length) && (c + offset2 < s2.length)) {
        if (s1.charAt(c + offset1) === s2.charAt(c + offset2)) {
            lcs++;
        } else {
            offset1 = 0;
            offset2 = 0;
            for (let i = 0; i < maxOffset; i++) {
                if ((c + i < s1.length) && (s1.charAt(c + i) === s2.charAt(c))) {
                    offset1 = i;
                    break;
                }
                if ((c + i < s2.length) && (s1.charAt(c) === s2.charAt(c + i))) {
                    offset2 = i;
                    break;
                }
            }
        }
        c++;
    }
    return (s1.length + s2.length) / 2 - lcs;
};

const findClosest = (value, list) => {
    if (list.indexOf(value) !== -1) return null;

    let bestDist = THRESHOLD;
    let best = null;
    for (const candidate of list) {
        const dist = sift3Distance(value, candidate);
        if (dist < bestDist) {
            bestDist = dist;
            best = candidate;
        }
    }
    return best;
};

export const suggestEmail = email => {
    if (!email || typeof email !== 'string') return null;

    const trimmed = email.trim().toLowerCase();
    const atIdx = trimmed.lastIndexOf('@');
    if (atIdx < 1 || atIdx === trimmed.length - 1) return null;

    const local = trimmed.slice(0, atIdx);
    const domain = trimmed.slice(atIdx + 1);
    if (domain.indexOf('.') === -1) return null;

    const closestDomain = findClosest(domain, DOMAINS);
    if (closestDomain) {
        return `${local}@${closestDomain}`;
    }

    const dotIdx = domain.indexOf('.');
    const sld = domain.slice(0, dotIdx);
    const tld = domain.slice(dotIdx + 1);
    const closestTld = findClosest(tld, TLDS);
    if (closestTld) {
        return `${local}@${sld}.${closestTld}`;
    }

    return null;
};
